import { getSiteConfig, useIntl } from '@openedx/frontend-base';
import { ActionRow, Button, ModalDialog } from '@openedx/paragon';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import messages from './messages';

const ProgressiveProfilingPageModal = (props) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { isOpen, redirectUrl } = props;
  const platformName = getSiteConfig().siteName;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (redirectUrl.startsWith('/')) {
      navigate(redirectUrl);
    } else {
      window.location.href = redirectUrl;
    }
  };

  return (
    <ModalDialog
      title={formatMessage(messages['modal.title'])}
      isOpen={isOpen}
      onClose={() => { }}
      size="sm"
      variant="default"
      hasCloseButton={false}
    >
      <ModalDialog.Header>
        <ModalDialog.Title>
          {formatMessage(messages['modal.title'])}
        </ModalDialog.Title>
      </ModalDialog.Header>

      <ModalDialog.Body>
        {formatMessage(messages['modal.description'])}
      </ModalDialog.Body>

      <ModalDialog.Footer>
        <ActionRow>
          <Button onClick={handleSubmit} variant="primary">
            {formatMessage(messages['continue.to.platform'], { platformName })}
          </Button>
        </ActionRow>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};

ProgressiveProfilingPageModal.propTypes = {
  isOpen: PropTypes.bool,
  redirectUrl: PropTypes.string.isRequired,
};

ProgressiveProfilingPageModal.defaultProps = {
  isOpen: false,
};

export default ProgressiveProfilingPageModal;
